import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Account() {
  const { user, refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState({ name: "", phone: "", email: "", address: "" });
  const [pw, setPw] = useState({ old_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user === false) navigate("/masuk?next=/akun");
    if (user) setProfile({ name: user.name || "", phone: user.phone || "", email: user.email || "", address: user.address || "" });
  }, [user, navigate]);

  const saveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await API.put("/auth/profile", profile);
      await refresh();
      toast.success("Profil berhasil disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    try {
      await API.put("/auth/password", pw);
      window.location.assign("/masuk?passwordChanged=1");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  const inputCls = "w-full bg-white border border-slate-300 rounded-md px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A227]";
  const labelCls = "text-xs font-bold uppercase tracking-[0.2em] text-slate-500 block mb-2";

  if (!user) return null;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 py-10" data-testid="account-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-display text-3xl tracking-tight">Akun Saya</h1>
            <p className="text-sm text-slate-500 mt-1">
              @{user.username} • {user.role === "owner" ? "Pemilik" : "Pelanggan"}
            </p>
          </div>
          <button onClick={async () => { await logout(); navigate("/"); }} data-testid="account-logout" className="px-5 py-2.5 border border-red-300 text-red-600 text-xs font-bold rounded-md hover:bg-red-50 transition-colors">
            Keluar
          </button>
        </div>

        <form onSubmit={saveProfile} className="bg-white border border-slate-200 rounded-md p-6 space-y-5" data-testid="profile-form">
          <h2 className="font-bold">Profil</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className={labelCls}>Nama Lengkap</label>
              <input required value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })} data-testid="profile-name" className={inputCls} />
            </div>
            <div>
              <label className={labelCls}>No. Telepon</label>
              <input required value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} data-testid="profile-phone" className={inputCls} />
            </div>
          </div>
          <div>
            <label className={labelCls}>Email</label>
            <input type="email" value={profile.email} onChange={(e) => setProfile({ ...profile, email: e.target.value })} data-testid="profile-email" className={inputCls} />
          </div>
          <div>
            <label className={labelCls}>Alamat Default</label>
            <textarea rows={2} value={profile.address} onChange={(e) => setProfile({ ...profile, address: e.target.value })} data-testid="profile-address" className={inputCls} />
          </div>
          <button type="submit" disabled={saving} data-testid="profile-save" className="px-6 py-3 bg-[#0B1F3A] bg-navy-hover text-white font-bold text-sm rounded-md transition-colors disabled:opacity-60">
            {saving ? "Menyimpan..." : "Simpan Profil"}
          </button>
        </form>

        <form onSubmit={savePassword} className="bg-white border border-slate-200 rounded-md p-6 space-y-5" data-testid="password-form">
          <h2 className="font-bold">Ubah Kata Sandi</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className={labelCls}>Kata Sandi Lama</label>
              <input required type="password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} data-testid="pw-old" className={inputCls} />
            </div>
            <div>
              <label className={labelCls}>Kata Sandi Baru</label>
              <input required type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="pw-new" className={inputCls} />
            </div>
          </div>
          <button type="submit" data-testid="pw-save" className="px-6 py-3 bg-gold bg-gold-hover text-[#0B1F3A] font-bold text-sm rounded-md transition-colors">
            Ubah Kata Sandi
          </button>
        </form>
      </div>
    </div>
  );
}
